<template >
    <div>
       <v-list-item  @click="carregarBoletim()"><v-icon>print</v-icon><span>Boletim</span></v-list-item >
        <!-- <v-list-item @click="carregarcartaoestudante()"><v-icon>print</v-icon><span>Cartão escolar</span></v-list-item> -->
        <!-- <v-list-item v-if="isFinalista" @click="carregarCartaRecomendacao()"><v-icon>print</v-icon><span>Carta de Recomendação</span></v-list-item> -->
        <!-- <v-list-item v-if="isFinalista" @click="carregarCertificado()"><v-icon>print</v-icon><span>Certificado</span></v-list-item> -->
        <v-list-item @click="declaracao()"><v-icon>print</v-icon><span>Declaração sem notas</span></v-list-item>
        <!-- <v-list-item @click="declaracao_notas()"><v-icon>print</v-icon><span>Declaração com notas</span></v-list-item> -->
        <!-- <v-list-item @click="carregarFichaDadosBiograficoAcademico()"><v-icon>print</v-icon><span>Ficha de Dados Biográfico Académico</span></v-list-item> -->
        <!-- <v-list-item @click="carregarGuiaTransferencia()"><v-icon>print</v-icon><span>Guia de Tranferência</span></v-list-item> -->
        <!-- <v-list-item @click="carregarHistoricoAcademico()"><v-icon>print</v-icon><span>Histórico Académico</span></v-list-item> -->

        <div>
            <guiatransferencia v-if="$store.state.showDialogGuia.guia" />
            <fichadadosbiograficoacademico v-if="$store.state.showDialogGuia.ficha" />
            <historicoacademico v-if="$store.state.showDialogGuia.historico" />
            <cartaoescolar v-if="$store.state.showDialogGuia.cartao" />
            <declaracaonotas v-if="$store.state.showDialogGuia.declaracao_nota" />
            <declaracao v-if="$store.state.showDialogGuia.declaracao" />
            <cartarecomendacao v-if="$store.state.showDialogGuia.carta" />
            <boletim v-if="showPopUp" @fecharComponente="fecharTelaComponente" />
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2'
const ls = require('local-storage')

export default {
    name: 'impressaoEstudante',
    props: ['estudante', 'estudante_dados'],
    data: () => ({
        titulo: '',
        showPopUp: false
    }),

    components: {
        guiatransferencia: () => import('../guiatransferencia.vue'),
        fichadadosbiograficoacademico: () => import('../fichadadosbiografico.vue'),
        historicoacademico: () => import('../historicoacademico.vue'),
        cartaoescolar: () => import('../cartao.vue'),
        declaracaonotas: () => import('../declaracao_nota.vue'),
        declaracao: () => import('../declaracao.vue'),
        cartarecomendacao: () => import('../carta.vue'),
        boletim: () => import('../boletim.vue'),
    },

    methods: {
        fecharTelaComponente() {
            this.showPopUp = false;
        },
        
        declaracao() {
            this.titulo = 'A Declaração sem Notas'
            ls.set('relatorio-estudante', { id: 8, descricao: 'Declaração sem Notas' })
            this.$store.state.objAluno = this.estudante
            this.$store.state.isloading = true
            this.$store.state.showDialogGuia.declaracao = true
        },

        carregarBoletim() {
            this.$store.state.objAluno = this.estudante
            this.showPopUp = true

            // this.$store.state.showDialogGuia.boletim = true
            // this.$store.state.backTo = '/estudante/historico-academico'
            // this.$router.push('/turma/Novo-Boletim')
        },

        carregarHistoricoAcademico() {
            this.titulo = 'O Histórico Académico'
            ls.set('relatorio-estudante', { id: 1, descricao: 'Histórico Académico' })
            this.$store.state.listEstudantfromPauta = this.estudante_dados
            this.$store.state.showDialogGuia.historico = true
            this.$store.state.isloading = true
        },

        carregarFichaDadosBiograficoAcademico() {
                this.titulo = 'A Ficha de Dados Biográfico Académico'
                ls.set('relatorio-estudante', { id: 3, descricao: 'Ficha de Dados Biográfico Académico' })
                this.$store.state.listEstudantfromPauta = this.estudante_dados
                this.$store.state.isloading = true
                this.$store.state.showDialogGuia.ficha = true
                },
            carregarCartaRecomendacao() {
            this.titulo = 'A Carta de recomendação'
            ls.set('relatorio-estudante', { id: 4, descricao: 'Carta de recomendação' })
            this.$store.state.objAluno = this.estudante
            this.$store.state.isloading = true
            this.$store.state.showDialogGuia.carta = true
            },
            carregarCertificado() {
                let item = this.estudante
                if (item.certificado == 1) {
                    window.open('http://certificado.softlineangola.com/#/login/?q=' + item.idMAtricula + '/' + ls.get('token'), '_blank').focus()
                } else {
                    this.$store.state.objaluno = item
                    this.$router.push('preparar-certificado-notas-PesquisaGeral')
                }
                },
            carregarGuiaTransferencia() {
            this.titulo = 'A Guia de Transferência'
            ls.set('relatorio-estudante', { id: 5, descricao: 'Guia de Transferência' })
            let i = 0
            this.estudante_dados.forEach(element => {
                if (i < element.idAno_Academico) {
                i = element.idAno_Academico
                this.$store.state.objAluno = element
                }
            })
            this.$store.state.isloading = true
            this.$store.state.showDialogGuia.guia = true
            },
            carregarcartaoestudante() {
            this.titulo = 'O Cartão de Estudante'
            ls.set('relatorio-estudante', { id: 6, descricao: 'Cartão de Estudante' })
            this.$store.state.objAluno = this.estudante
            this.$store.state.isloading = true
            this.$store.state.showDialogGuia.cartao = true
            },
            declaracao_notas() {
            this.titulo = 'A Declaração com Notas'
            ls.set('relatorio-estudante', { id: 7, descricao: 'Declaração com Notas' })
            this.$store.state.objAluno = this.estudante
            this.$store.state.showDialogGuia.declaracao_nota = true
            },
    }
}
</script>
<style>
</style>